<div [attr.id]="id" class="sub-dashboard-card" (click)="onCardClick()" tabindex="0" style="cursor:pointer;">
    <div class="sub-dashboard-card__left">
        <div class="icon-container">
            <img [src]="iconSrc" alt="" />
        </div>
        <p class="summary-text">{{ text }}</p>
    </div>
    <img class="ceveron-icon" [src]="chevronIconSrc" alt="" />
</div>